import { init_from_snippet } from './posthog-core'

init_from_snippet()
